import { UrlParser } from "../Utils/UrlParser";
import { eAdMode, eAdState, eAdShowRes, eSDKType, SDKBase } from "./SDKBase";



export const enum eVKPlatform {
    web,
    mobileWeb,
    iOSClient,
    androidClient
}



export class VKAd {
    get mode(): eAdMode { return this._mode; }
    private _mode: eAdMode;

    get state(): eAdState { return this._state; }
    private _state: eAdState;

    private _adman: any;
    private _skipped: boolean;

    /**
     * Udalost vyvolana po dokonceni prehravani reklamy
     * Parametry:
     * this: VKAd
     * res: eAdShowRes
     * callbackPar: any
     */
    static readonly EVENT_COMPLETE = "vkAd:complete";

    /**
     * Udalost vyvolana po nacteni reklamy
     * Parametry:
     * this: VKAd
     * res: boolean
     */
    static readonly EVENT_LOADED = "vkAd:loaded";

    private _callbackPar: any;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(mode: eAdMode) {
        this._mode = mode;
        this._state = eAdState.none;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    load(): boolean {
        if (this._state == eAdState.ready)
            return false;

        this._state = eAdState.loading;

        if ((<any>window).admanInit) {
            (<any>window).admanInit({
                user_id: VK.instance.userId,
                app_id: VK.instance.appId,
                mobile: VK.instance.platform == eVKPlatform.mobileWeb,
                //params: { preview: 1 },
                type: (this._mode == eAdMode.videoReward ? "rewarded" : "preloader")
            }, (adman: any) => {
                this._adman = adman;
                this._state = eAdState.ready;

                adman.onStarted(() => { this._state = eAdState.playing; });
                adman.onCompleted(() => { this._state = eAdState.none; VK.instance.eventHandler.fire(VKAd.EVENT_COMPLETE, this, this._skipped ? eAdShowRes.skipped : eAdShowRes.success, this._callbackPar); });
                adman.onSkipped(() => { this._skipped = true; });

                VK.instance.eventHandler.fire(VKAd.EVENT_LOADED, this, true);
            }, () => {
                this._state = eAdState.none;
                VK.instance.eventHandler.fire(VKAd.EVENT_LOADED, this, false);
            });

            return true;
        }
        else {
            VK.instance.eventHandler.fire(VKAd.EVENT_LOADED, this, false);
        }

        this._state = eAdState.none;
        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(callbackPar: any): void {
        if (this._state != eAdState.ready) {
            VK.instance.eventHandler.fire(VKAd.EVENT_COMPLETE, this, eAdShowRes.failed, this._callbackPar);
            return;
        }

        // Spustit pripravenou reklamu
        this._skipped = false;
        this._callbackPar = callbackPar;
        this._adman.start('preroll');
    }
}



export class VK extends SDKBase {
    static get instance(): VK { return VK._self; }
    private static _self: VK;

    get appId(): number { return this._appId; }
    private _appId: number = 0;

    get userId(): number { return this._userId; }
    private _userId: number = 0;

    /**
     * (RO) Platforma
     */
    get platform(): eVKPlatform { return this._platform; }
    private _platform: eVKPlatform;

    private _ads: VKAd[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(app: pc.Application) {
        super(app, eSDKType.VK);

        VK._self = this;

        // Reklama
        this._ads = [];
        this._ads[eAdMode.videoReward] = new VKAd(eAdMode.videoReward);
        this._ads[eAdMode.videoSkippable] = new VKAd(eAdMode.videoSkippable);

        this._eventHandler.on(VKAd.EVENT_LOADED, this.handleAdLoaded, this);
        this._eventHandler.on(VKAd.EVENT_COMPLETE, this.handleAdComplete, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(): void {
        this._api = (<any>window).vkBridge;

        if (this._api) {
            this._api.send('VKWebAppInit');

            UrlParser.parseUri();

            // User ID
            let par = UrlParser.getParam("viewer_id");

            if (par != undefined)
                this._userId = parseInt(par);

            // App ID
            if ((par = UrlParser.getParam("api_id")) != undefined)
                this._appId = parseInt(par);

            // Platform
            let platform = UrlParser.getParam("platform");

            this._platform = (platform == null || platform == undefined || platform == "web" ? eVKPlatform.web : platform == "html5_mobile" ? eVKPlatform.mobileWeb : platform == "html5_android" ? eVKPlatform.androidClient : eVKPlatform.iOSClient);

            this._initialized = true;
            this._eventHandler.fire(VK.EVENT_INITIALIZED, true);
        }
        else {
            console.log("vkBridge doesn't exist");
            this._eventHandler.fire(VK.EVENT_INITIALIZED, false);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    loadAd(mode: eAdMode): boolean {
        if (!this._initialized)
            return false;

        if (this.platform == eVKPlatform.androidClient || this.platform == eVKPlatform.iOSClient) {
            this._adState[mode] = eAdState.ready;
            return true;
        }

        this._ads[mode].load();
        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showAd(adMode: eAdMode, callbackPar: any): boolean {
        if (super.showAd(adMode, callbackPar)) {
            if (this.platform == eVKPlatform.androidClient || this.platform == eVKPlatform.iOSClient) {
                this._api.sendPromise("VKWebAppShowNativeAds", { ad_format: adMode == eAdMode.videoReward ? "reward" : "preloader" })
                    .then((data: any) => {
                        this._adState[adMode] = eAdState.none;
                        this._eventHandler.fire(VK.EVENT_AD_COMPLETE, data.result ? eAdShowRes.success : eAdShowRes.skipped, callbackPar);
                    })
                    .catch((error: any) => {
                        this._adState[adMode] = eAdState.none;
                        this._eventHandler.fire(VK.EVENT_AD_COMPLETE, eAdShowRes.failed, callbackPar);
                    });
            }
            else {
                this._ads[adMode].show(callbackPar);
            }

            return true;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showInvite(): void {
        if (this._api) {
            this._api.send("VKWebAppShowInviteBox")
                .then((data: any) => { })
                .catch((error: any) => { });
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAdLoaded(ad: VKAd, res: boolean): void {
        this._adState[ad.mode] = (res ? eAdState.ready : eAdState.none);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAdComplete(ad: VKAd, res: eAdShowRes, par: any): void {
        this._adState[ad.mode] = eAdState.none;
        this._eventHandler.fire(VK.EVENT_AD_COMPLETE, res, par);
    }
}